/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Heading, Stack, Text } from "components";

import { useAppAssetsWithSrc } from "Theme/EVENTS_ASSETS";
import { useOrgData } from "state/OrgDataContext";
import { useUI } from "state";
import { useTranslation } from "react-i18next";
import { ScreenPage } from "templates";

const ExitPage = () => {
  const { t } = useTranslation();
  const { colorScheme } = useUI();
  const EVENT_ASSETS = useAppAssetsWithSrc();
  const { dataContent: EVENT_CONTENT } = useOrgData();

  return (
    <ScreenPage
      desktopBG={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_desktop.src
          : EVENT_ASSETS.alldone_BG_desktopDark.src
      }
      desktopBGFallback={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_desktop.fallbackSrc
          : EVENT_ASSETS.alldone_BG_desktopDark.fallbackSrc
      }
      mobileBG={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_mobile.src
          : EVENT_ASSETS.alldone_BG_mobileDark.src
      }
      mobileBGFallback={
        colorScheme === "light"
          ? EVENT_ASSETS.alldone_BG_mobile.fallbackSrc
          : EVENT_ASSETS.alldone_BG_mobileDark.fallbackSrc
      }
      showNotification={false}
      showLogo={true}
    >
      <Stack component="article" className="h-full w-full">
        <div className="flex items-center gap-x-3">
          <Heading
            as="h2"
            className="text-2xl md:text-[32px] -text--theme-colors-text-title"
          >
            {t("exit.sorryMSG")}
          </Heading>
        </div>
        <Text className="-text--theme-colors-text-body text-sm md:text-base mt-[32px]">
          {t("exit.feedbackMSG")}
          <br />
        </Text>
        <div className="mt-3">
          <Text
            as="span"
            className="-text--theme-colors-text-body text-sm md:text-base"
          >
            {t("exit.emailMSG")}{" "}
            <a
              href="mailto:info@theunityapp.ph"
              className="font-normal -text--theme-colors-text-subtitle-brand"
            >
              <span className="underline">{EVENT_CONTENT.exit.exitEmail}</span>
            </a>
            {t("exit.forAnyQuestionsMSG")}
          </Text>
        </div>
      </Stack>
    </ScreenPage>
  );
};
export default ExitPage;
